import _ from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonIcon,
  IonContent,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";

import { FileSelector } from "../../components";
import { uploadFiles } from "../../modules";

import styled from "styled-components";
const ModalContent = styled(IonContent)``;
const CloseIcon = styled(IonIcon)`
  margin-right: 8px;
  font-size: 1.5em;
`;

const FileSelectorContainer = styled.div`
  padding: 8px;
`;

const FileUploadModal = (props) => {
  const handleSubmitUpload = (selectedFiles) => {
    const values = {
      auth_token: _.get(props.credentials, "authToken"),
      group_id: props.groupId,
      // context: props.context,
      parent_object_id: props.parentId,
      parent_content_type_app_label: props.parentContentTypeAppLabel,
      parent_content_type_model: props.parentContentTypeModel,
      view_permission_type: props.uploadViewPermissionType,
      delete_permission_type: props.uploadDeletePermissionType,
      files: selectedFiles,
    };

    props.uploadFiles({ values });
  };

  return (
    <IonModal
      {...props}
      onDidDismiss={() => {
        props.handleClose();
      }}
    >
      <ModalContent>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>Upload Files</IonTitle>
            <CloseIcon
              slot="end"
              icon={closeOutline}
              onClick={props.handleClose}
            />
          </IonToolbar>
        </IonHeader>
        <FileSelectorContainer>
          <FileSelector
            submitButtonText={"Upload files"}
            onSubmit={handleSubmitUpload}
            uploadFilesProgress={props.uploadFilesProgress}
          />
        </FileSelectorContainer>
      </ModalContent>
    </IonModal>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadFiles,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(FileUploadModal);
